module.exports = __webpack_public_path__ + "static/fonts/notokr-light.2ea9b0e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/concierge/font/notosanskr/notokr-light.woff
// module id = Fv4k
// module chunks = 0